import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按类型浏览，快速找到喜欢的漫画
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl hover:bg-primary-50 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-700 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-all">
                <i className={`ri-${getCategoryIcon(cat.slug)} text-2xl`} />
              </div>
              <span className="font-heading text-sm md:text-base text-foreground-700 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function getCategoryIcon(slug: string): string {
  const iconMap: Record<string, string> = {
    rexue: 'fire-line',
    lianai: 'heart-line',
    gaoxiao: 'emotion-happy-line',
    qihuan: 'magic-line',
    xuanyi: 'search-eye-line',
    kehuan: 'rocket-line',
    richang: 'sun-line',
    kongbu: 'ghost-line',
    maoxian: 'compass-line',
  };
  return iconMap[slug] || 'book-line';
}